export default __webpack_public_path__ + "static/media/mjunction1.a9653612.png";